import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function FavoritesIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M10.2611 3.89255C11.0362 2.58837 12.9244 2.58837 13.6996 3.89256L15.5744 7.04694L19.1618 7.88817C20.6218 8.23056 21.1996 9.99856 20.2235 11.1371L17.7957 13.9689L18.1134 17.676C18.2424 19.181 16.7205 20.2803 15.3323 19.6848L11.9803 18.2469L8.62832 19.6848C7.24013 20.2803 5.71819 19.181 5.84719 17.676L6.16493 13.9689L3.73713 11.1371C2.76102 9.99856 3.33881 8.23056 4.79888 7.88817L8.38621 7.04694L10.2611 3.89255Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<FavoritesIcon fill={props.fill} />
		</div>
	);
}